var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-row",
    [
      _c(
        "ib-col",
        {
          staticClass: "scroll flex  after-8",
          staticStyle: { "max-height": "65vh" },
        },
        [
          _c(
            "ib-table-basic",
            {
              staticClass: "fs7 fg70 shrink",
              staticStyle: {
                border: "1px solid rgba(0,0,0,0.15)",
                "overscroll-behavior": "contain",
              },
              attrs: {
                data: _vm.listedResults,
                row: "",
                colborder: "",
                spacing: "huge",
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function (res) {
                    return [
                      _c(
                        "td",
                        [
                          _c(
                            "ib-button",
                            {
                              staticClass: "description",
                              attrs: { appearance: "link", title: res["name"] },
                              on: {
                                click: function ($event) {
                                  return _vm.exchangeOverview(res["id"])
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(res["id"]) +
                                  " (" +
                                  _vm._s(res["name"]) +
                                  ")"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("td", { attrs: { title: res["assets"] } }, [
                        _vm._v(_vm._s(res["assets"])),
                      ]),
                      _c("td", { attrs: { title: res["country"] } }, [
                        _vm._v(_vm._s(res["country"])),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "ib-table-col",
                { staticClass: "header", attrs: { width: "30ch", sticky: "" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "border-bottom",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.sortResults("id", "")
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { title: _vm.$t("description") } }, [
                        _vm._v(_vm._s(_vm.$t("description"))),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "up",
                          class: {
                            "active-sort":
                              _vm.previousSort.type === "company" &&
                              _vm.previousSort.dir === "asc",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("id", "asc")
                            },
                          },
                        },
                        [
                          _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                            _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                          ]),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "down",
                          class: {
                            "active-sort":
                              _vm.previousSort.type === "company" &&
                              _vm.previousSort.dir === "desc",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("id", "desc")
                            },
                          },
                        },
                        [
                          _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                            _c("path", { attrs: { d: "M4 17l21 22 21-22z" } }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "ib-table-col",
                { staticClass: "header", attrs: { width: "14ch" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "border-bottom",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.sortResults("assets", "")
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { title: _vm.$t("product") } }, [
                        _vm._v(_vm._s(_vm.$t("product"))),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "up",
                          class: {
                            "active-sort":
                              _vm.previousSort.type === "company" &&
                              _vm.previousSort.dir === "asc",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("assets", "asc")
                            },
                          },
                        },
                        [
                          _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                            _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                          ]),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "down",
                          class: {
                            "active-sort":
                              _vm.previousSort.type === "company" &&
                              _vm.previousSort.dir === "desc",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("assets", "desc")
                            },
                          },
                        },
                        [
                          _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                            _c("path", { attrs: { d: "M4 17l21 22 21-22z" } }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "ib-table-col",
                { staticClass: "header", attrs: { width: "14ch" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "border-bottom",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.sortResults("country", "")
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { title: _vm.$t("region") } }, [
                        _vm._v(_vm._s(_vm.$t("region", "")) + "`"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "up",
                          class: {
                            "active-sort":
                              _vm.previousSort.type === "company" &&
                              _vm.previousSort.dir === "asc",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("country", "asc")
                            },
                          },
                        },
                        [
                          _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                            _c("path", { attrs: { d: "M25 13L4 35h42z" } }),
                          ]),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "down",
                          class: {
                            "active-sort":
                              _vm.previousSort.type === "company" &&
                              _vm.previousSort.dir === "desc",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.sortResults("country", "desc")
                            },
                          },
                        },
                        [
                          _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                            _c("path", { attrs: { d: "M4 17l21 22 21-22z" } }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.listedResults.length > 0
            ? _c("div", { staticClass: "pagination" }, [
                _c(
                  "div",
                  { staticClass: "dropdownStyle" },
                  [
                    _c("ib-dropdown", {
                      attrs: {
                        data: _vm.dropdownData,
                        placeholder: _vm.$t("show_rows"),
                        align: "center",
                      },
                      model: {
                        value: _vm.numShow,
                        callback: function ($$v) {
                          _vm.numShow = $$v
                        },
                        expression: "numShow",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pagination-style" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("page")))]),
                    _c("ib-field", {
                      staticClass: "outsetx-8",
                      attrs: {
                        disabled: _vm.totalPage <= 1,
                        width: "7ch",
                        align: "center",
                        placeholder: "1",
                      },
                      on: { change: _vm.changePage },
                      model: {
                        value: _vm.pageNumber,
                        callback: function ($$v) {
                          _vm.pageNumber = $$v
                        },
                        expression: "pageNumber",
                      },
                    }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("of"))),
                      _c("strong", { staticStyle: { "margin-left": "4px" } }, [
                        _vm._v(_vm._s(_vm.totalPage)),
                      ]),
                    ]),
                    _c(
                      "ib-button",
                      {
                        staticClass: "page-btn",
                        attrs: { disabled: _vm.pageNumber <= 1 },
                        on: {
                          click: function ($event) {
                            return _vm.changePage(--_vm.pageNumber)
                          },
                        },
                      },
                      [
                        _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                          _c("path", {
                            attrs: {
                              d: "M14.78 2.28l-9 9-.69.72.7.72 9 9 1.43-1.44L7.94 12l8.28-8.28z",
                            },
                          }),
                        ]),
                      ]
                    ),
                    _c(
                      "ib-button",
                      {
                        staticClass: "page-btn",
                        attrs: { disabled: _vm.pageNumber >= _vm.totalPage },
                        on: {
                          click: function ($event) {
                            return _vm.changePage(++_vm.pageNumber)
                          },
                        },
                      },
                      [
                        _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                          _c("path", {
                            attrs: {
                              d: "M8.7 2.3L7.3 3.7l8.29 8.3-8.3 8.3 1.42 1.4 9.7-9.7z",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }